// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"22ae1364","453":"b9f87c22","732":"fc87636d"}[chunkId] + ".chunk.js";
};